import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { gitConnectionSetup } from '../../docs-routes'

const GitConnectionSetup = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Adding a connection to your Git repository allows you to access your project's suite(s) from DAI.
    </Color>
    <DocusaurusFooter path={gitConnectionSetup} />
  </Paragraph>

export default GitConnectionSetup
